<template>
  <div>
    <div class="vx-row mx-auto">
      <div class="vx-col xl:w-1/3 lg:w-1/3 md:w-full sm:w-full xs:w-full mb-4">
        <vx-card id="full-library-search-card" title="" class="school-primary_gradient--opaque glow-effect_dark">
          <div class="vx-row mb-4">
            <div class="vx-col w-full">
              <h2 class="float-left">FULL LIBRARY</h2>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full mb-3">
              <vx-card class="card__no-padding">
                <vx-input-group>
                  <template slot="prepend">
                    <div class="prepend-text school-primary_gradient">
                      <span><feather-icon class="pt-1" icon="BookIcon" svg-classes="stroke-current"></feather-icon></span>
                    </div>
                  </template>

                  <v-select
                    id="categorydropdown"
                    ref="genreDropdown"
                    class="w-full style-chooser-light"
                    placeholder="Search / Select a Category"
                    :options="genres"
                    v-model="genreDropdown"
                    style="height: 50px;"
                  />
                </vx-input-group>
              </vx-card>
            </div>
            <div class="vx-col w-full mb-3">
              <p class="font-white" style="font-size: 16pt"><strong>OR</strong></p>
            </div>
            <div class="vx-col w-full">
              <vx-input-group class="full-search_input-group">
                <vs-input v-model="inputSearchQuery" class="w-full full-search-input" placeholder="Search Author, Title, Summary, Tags" />

                <!-- <template slot="append">
                  <div class="append-text school-primary_gradient">
                    <span><feather-icon class="pt-1" icon="SearchIcon" svg-classes="stroke-current"></feather-icon></span>
                  </div>
                </template> -->
              </vx-input-group>
            </div>
          </div>
          <div class="vx-row mt-3">
            <div class="vx-col w-full">
              <vs-button
                style=""
                ref="search"
                class="custom-button_library mt-2 vs-con-loading__container school-primary_gradient glow-effect_tertiary"
                @click="search">
                <img style="float:left; margin-left:-7px; margin-right:5px; margin-top:-2px; height:25px" src="https://lateralscaffolding.blob.core.windows.net/resources/icon-search-custom.png"/>
                <strong>{{ !(inputSearchQuery || genreDropdown) ? 'Show All' : 'Search' }}</strong>
              </vs-button>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select';
export default {
  components: {
    vSelect
  },
  data() {
    return {
      genreDropdown: 0,
      genres: [],
      inputSearchQuery: ""
    }
  },
  computed: {
    
  },
  watch: {
    
  },
  methods: {
    getGenres(whenDone) {
      var self = this;
      var onSuccess = response => {
        self.genres = response.data.map((item) => { return { label: item.text, value: item.value } });
        localStorage.setItem('categories', JSON.stringify(self.genres));
        if (whenDone && typeof whenDone == "function")
          whenDone();
      };

      self.$ajaxGet(self, "LibraryResource/ListGenres", onSuccess);
    },
    search() {
      var self = this;

      if (self.genreDropdown && self.inputSearchQuery) {
        self.$router.push({ name: 'FullLibrary', query: { q: self.inputSearchQuery, c: self.genreDropdown.value } });
      }
      else if (self.genreDropdown) {
        self.$router.push({ name: 'FullLibrary', query: { c: self.genreDropdown.value } });
      }
      else if (self.inputSearchQuery) {
        self.$router.push({ name: 'FullLibrary', query: { q: self.inputSearchQuery } });
      }
      else {
        self.$router.push({ name: 'FullLibrary' });
      }
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
  },
  mounted() {
    var self = this;
    self.$store.dispatch("updateTheme", "dark");
    localStorage.removeItem('categories');
    self.getGenres();
  }
};
</script>
<style lang="scss">
  #categorydropdown {
    .vs__actions {
      display: contents !important;

      .open-indicator {
        margin-right: 10px !important;
      }
    }
  }
</style>
